import { Button, Container } from "react-bootstrap";

function GetStartedSection() {
    return (
        <div className="get-started-section">
            <Container>
                <span className="personalized-text">Your  personalized path to success!</span>
                <h2>Ready to get started?</h2>
                <p>Examally is a platform that personalizes study materials for Leaving Cert exams. To learn more view our tutorials.</p>
                <Button variant="primary">View Tutorials</Button>
                <span className="copyright-text">&copy; 2025 Examally Inc</span>
            </Container>
        </div>
    )
}
export default GetStartedSection;